<template>
    <div class="newshuo">
        <topMenu :linkList="linkList"></topMenu>
        <section class="section" id="section1">
            <div class="section1-inner">
                 <div class="new-shuo-form-box">
                    <div class="section1-left">
                        
                    </div>
                <div class="section1-right">
                   
                <div id="registryForAmazon"></div>
            </div>
                </div>
            </div>
            
        </section>
        <div class="aff-section7">
            <div class="section7SwiperList">
                <div class="shadow leftShadow"></div>
                <div class="shadow rightShadow"></div>
                <div class="marquee section7Swiper1">
                    <div class="marquee__track flex items-center">
                        <div class="swiper-slide">
                            <div class="swiperWordTag">搭建交易系统</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon1.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">理解庄家行为</div>
                        </div>

                        <div class="swiper-slide">
                            <div class="swiperWordTag">高效盈亏管理</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon2.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">价格行为分析</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">透视波动真相</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon3.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">交易员实战分享</div>
                        </div>

                    </div>
                </div>
                <div class="marquee section7Swiper2">
                    <div class="marquee__track flex items-center marquee--reverse">
                        <div class="swiper-slide">
                            <div class="swiperWordTag">实战进阶落地</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon5.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">洞悉市场本质</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon6.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">全球宏观视野</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">重塑交易心理</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon7.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">多层级风险控制</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">资金和仓位管理</div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <section class="section" id="section2">
            <img class="pc-img" src="../assets/image/newshuo/section2.jpg" alt="">
            <img class="mobile-img" src="../assets/image/newshuo/section2_m.jpg" alt="">
        </section>
        <section class="section" id="section3">
            <img class="pc-img" src="../assets/image/newshuo/section3.jpg" alt="">
            <img class="mobile-img" src="../assets/image/newshuo/section3_m.jpg" alt="">
        </section>
        <section class="section" id="section4">
            <img class="pc-img" src="../assets/image/newshuo/section4.jpg" alt="">
            <img class="mobile-img" src="../assets/image/newshuo/section4_m.jpg" alt="">
        </section>
    </div>
</template>

<script>
import topMenu from '../components/topMenu/topMenu.vue';
import { mapGetters } from 'vuex';
import '@/assets/css/registryForAmazon.css';

export default {
    components: {
        topMenu
    },
    data() {
        return {
            linkList: [
                { name: "交易领书", target: "section2" },
                { name: "领取步骤", target: "section3" },
                { name: "活动规则", target: "section4" },
            ]
        }
    },
    mounted() {
        this.initPage()
        this.initRegistryForAmazon()
    },
    methods: {
        ensureVue3GlobalLoaded() {
            const VueGlobal = typeof window !== 'undefined' ? window.Vue : undefined
            if (VueGlobal && typeof VueGlobal.defineComponent === 'function') {
                return Promise.resolve()
            }

            const existing = document.querySelector('script[data-vue3-global="1"]')
            if (existing) {
                return new Promise((resolve, reject) => {
                    existing.addEventListener('load', () => resolve(), { once: true })
                    existing.addEventListener('error', (e) => reject(e), { once: true })
                })
            }

            const candidates = [
                'https://cdn.jsdelivr.net/npm/vue@3/dist/vue.global.prod.js',
                'https://unpkg.com/vue@3/dist/vue.global.prod.js',
            ]

            const loadFrom = (index) =>
                new Promise((resolve, reject) => {
                    const url = candidates[index]
                    if (!url) {
                        reject(new Error('Vue3 global 加载失败（CDN 不可用）'))
                        return
                    }

                    const script = document.createElement('script')
                    script.setAttribute('data-vue3-global', '1')
                    script.async = true
                    script.src = url
                    script.onload = () => resolve()
                    script.onerror = () => {
                        script.remove()
                        loadFrom(index + 1).then(resolve, reject)
                    }
                    document.head.appendChild(script)
                })

            return loadFrom(0)
        },
        ensureRegistryForAmazonScriptLoaded() {
            const registry =
                (typeof window !== 'undefined' && window.registry) ||
                (typeof globalThis !== 'undefined' && globalThis.registry)

            if (registry && typeof registry.create === 'function') {
                return Promise.resolve()
            }

            return new Promise((resolve, reject) => {
                const existing = document.querySelector('script[data-registry-for-amazon="1"]')
                if (existing) {
                    existing.addEventListener('load', () => resolve(), { once: true })
                    existing.addEventListener('error', (e) => reject(e), { once: true })
                    return
                }

                const baseUrl = (process.env.BASE_URL || '/').replace(/\/?$/, '/')
                const script = document.createElement('script')
                script.setAttribute('data-registry-for-amazon', '1')
                script.async = true
                script.src = `${baseUrl}registryForAmazon.umd.cjs`
                script.onload = () => resolve()
                script.onerror = (e) => reject(e)
                document.head.appendChild(script)
            })
        },
        async initRegistryForAmazon() {
            try {
                await this.$nextTick()
                await this.ensureVue3GlobalLoaded()
                await this.ensureRegistryForAmazonScriptLoaded()

                const registry =
                    (typeof window !== 'undefined' && window.registry) ||
                    (typeof globalThis !== 'undefined' && globalThis.registry)

                if (!registry || typeof registry.create !== 'function') {
                    console.error('[newshuo] registry 未加载或未暴露 create()')
                    return
                }

                const widget = registry.create("#registryForAmazon");
                widget && typeof widget.changeLanguage === 'function' && widget.changeLanguage("zh");
                console.log("widget",WebGLRenderingContext)
                setTimeout(()=>{
                    widget.changeLanguage("zh");
                },200)
                setTimeout(()=>{
                    widget.changeLanguage("zh");
                },500)
                setTimeout(()=>{
                    widget.changeLanguage("zh");
                },1000)
                setTimeout(()=>{
                    widget.changeLanguage("zh");
                },2000)
            } catch (e) {
                console.error('[newshuo] registryForAmazon 初始化失败', e)
            }
        },
        async initPage() {
            console.log("in")
            function initMarquee(track, index) {
                if (!track) return;
                const originalContent = track.innerHTML;
                track.style.animationPlayState = 'paused';
                console.log("in2")
                // 等浏览器渲染
                requestAnimationFrame(() => {
                    const originalWidth = track.scrollWidth;
                    track.innerHTML = originalContent + originalContent + originalContent + originalContent;
                    track.style.width = (originalWidth * 4) + 'px';
                    track.style.setProperty('--s7move-distance', `-${originalWidth * 2}px`);
                    track.style.animation = 'none';
                    requestAnimationFrame(() => {
                        console.log("in3")
                        track.style.animation = 'marquee 140s linear infinite';
                        index == 1 && (track.style.animationDirection = 'reverse')
                    });
                });
            }
            document.querySelectorAll('.marquee__track').forEach((track, index) => {
                initMarquee(track, index)
            });
        }
    },
    computed: {

        ...mapGetters([
            'signupUrl',
        ])
    },
}
</script>

<style lang="scss">
html {
  font-size: 0.052083vw !important;
}

body {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    /* 自动匹配用户系统默认字体 */

}

.el-dropdown-menu a {
    color: #666;
}

.newshuo .pc-img {
    width: 1920rem;
    margin: 0 ;
}

.newshuo .mobile-img {
    display: none;
    margin: 0 ;
}

.newshuo {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;

.section{
    width: 100%;
}

#section1{
    position: relative;
    width: 100%;
    /* 高保真图：2880x1253；宽度=容器宽度，高度按比例自适应 */
   height: 902rem;
    background-image: url("../assets/image/newshuo/section1.jpg");
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
}

.section1-inner{
    position: absolute;
    left: 0;
    top: 0;
    height: 834rem;
}

.new-shuo-form-box{
    margin: 0 auto;
    width:1920rem;
    
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 120rem 360rem 0;
}
.form-box {
    margin-bottom: 4rem;
}
.section-form{
   width: 460rem;
}

    /* 自动匹配用户系统默认字体 */
    .link-a {
       
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 48rem;
        min-width: 220rem;
        gap: 8rem;
        border-radius: 24rem;
        background: var(--Brand-Secondary-Red, #a52933);
        color: #fff;
        text-align: center;
        font-size: 16rem;
        font-style: normal;
        line-height: 28rem;
        cursor: pointer;
        font-weight: 500;
        margin-top: 280rem;
    }

    .link-a:hover {
        background: var(--Text-Primary_White, #fff);
        color: var(--Brand-Secondary-Red, #a52933);
    }

    .aff-section7 .shadow {
        position: absolute;
        top: 0;
        height: 100%;
        width: 330rem;
        z-index: 2;
    }

    .aff-section7 .leftShadow {
        background: linear-gradient(270deg, rgba(245, 245, 245, 0) 0%, #f5f5f5 100%);
        left: 0;
    }

    .aff-section7 .rightShadow {
        background: linear-gradient(270deg, #f5f5f5 0%, rgba(245, 245, 245, 0) 100%);
        right: 0;
    }


    .aff-section7 .swiperWordTag {
        border-radius: var(--Corner-Radius-Full, 999px);
        background: #fff;
        backdrop-filter: blur(8px);
        padding: 12rem 28rem;
    }

    .aff-section7 .swiperLogoTag {
        width: 48rem;
        height: 48rem;
    }

    .aff-section7 .section7SwiperList {
        padding: 60rem 0 32rem;
        background: #F9F6F2;
        position: relative;
    }

    .aff-section7 .section7SwiperList .marquee:nth-child(-n + 4) {
        margin-bottom: 28rem;
    }

    .aff-section7 .swiper-slide {
        width: fit-content;

        color: #9F734C;
        text-align: center;
        font-size: 20rem;
        font-weight: 500;
        line-height: 1;
    }

    .marquee {
        overflow: hidden;
        width: 100%;
    }

    .marquee--reverse.marquee__track {
        animation-direction: reverse;
    }

    .marquee__track {
        display: inline-flex;
        /* align-items: center; */
        gap: 20px;
        /* 对应 spaceBetween */

        /* 强制硬件加速 */
        /* transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0); */
        /* will-change: transform; */
        /* backface-visibility: hidden; */
        /* -webkit-backface-visibility: hidden; */
        animation: marquee 140s linear infinite;
        /* 调整 30s 控制速度 */
    }


}


@media (max-width: 996px) {
     html {
    font-size: 0.133333vw !important;
  }
    .newshuo .pc-img {
        width: 100%;
        display: none;
    }

    .newshuo .mobile-img {
        display: block;
        width: 100%;
    }

    .newshuo {
#section1{
    /* 高保真图：1500x3996；宽度=容器宽度，高度按比例自适应 */
    height: 2100rem;
    background-image: url("../assets/image/newshuo/section1_m.jpg");
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
}

.section1-inner{
height: auto;
}
.new-shuo-form-box{
flex-direction: column;
padding: 780rem 0 0;
width: 750rem;
align-items: center;
}
.section-form{
    width: 690rem;
}
        .link-a {
            
            display: inline-flex;
            font-size: 32rem;
            font-style: normal;
            font-weight: 500;
            line-height: 56rem;
            min-width: 450rem;
            padding: 0 30rem;
            height: 80rem;
            border-radius: 40rem;
        }

        // margin-top: -88rem;

        .aff-section7 .section7SwiperList .marquee:nth-child(-n + 4) {
            margin-bottom: 45rem;
        }

        .aff-section7 .swiperWordTag {
            padding: 20rem 46rem;
        }

        .aff-section7 .swiper-slide {
            font-size: 33rem;
            transition: none;

        }

        .marquee__track {
            gap: 33rem;
            animation: marquee 140s linear infinite;
            /* 调整 30s 控制速度 */
        }

        .aff-section7 .shadow {
            width: 130rem;
        }

        .aff-section7 .swiperLogoTag {
            width: 80rem;
            height: 80rem;
        }
    }
}

@keyframes marquee {
    0% {
        transform: translate3d(0, 0, 0);
    }

    100% {
        transform: translate3d(var(--s7move-distance), 0, 0);
    }
}
</style>